import { Navigate } from 'react-router-dom';
// layouts
import DashboardLayout from './layouts/dashboard';
import SimpleLayout from './layouts/simple';
//

import LoginPage from './pages/LoginPage';
import Page404 from './pages/Page404';
import UserPage from './pages/UserPage';

import AddUser from './components/User/AddUser';
import EditUser from './components/User/EditUser';
import ClientListPage from './pages/Clients/ClientListPage';
import ClientPage from './pages/Clients/ClientPage';
import CompanyDetailsPage from './pages/Company/CompanyDetailsPage';
import CompanyEditPage from './pages/Company/CompanyEditPage';
import CompanyListPage from './pages/Company/CompanyListPage';
import CompanyPage from './pages/Company/CompanyPage';
import DashboardAppPage from './pages/DashboardAppPage';

import ClientAssigmnet from './pages/Clients/ClientAssigmnet';
import ClientEditPage from './pages/Clients/ClientEditPage';

import CreateEnquiry from './components/Footfalls/CreateEnquiry';
import AddFootfall from './components/Footfalls/CreateFootfall';
import EditFootfall from './components/Footfalls/EditFootFall';
import FootFallDetails from './components/Footfalls/FootFallDetails';
import Association from './components/Opportunities/Association';
import PerformActivity from './components/Opportunities/PerformActivity';
import TasksList from './components/Opportunities/TasksList';
import AddPosition from './components/Positions/CreatePosition';
import ChangePassword from './components/User/ChangePassword';
import CreateJob from './components/Vacancies/CreateJob';
import AddVacancy from './components/Vacancies/CreateVacancy';
import EditVacancy from './components/Vacancies/EditVacancy';
import VacancyDetails from './components/Vacancies/VacancyDetails';
import AttachmentsList from './pages/Attachments/AttachmentsList';
import MyCalendar from './pages/Calendar/Calendar';
import CandidateCreatePage from './pages/Candidates/CandidateCreatePage';
import CandidateEditPage from './pages/Candidates/CandidateEditPage';
import CandidateTabsPage from './pages/Candidates/CandidateTabsPage';
import CandidatesList from './pages/Candidates/CandidatesList';
import ClientDetails from './pages/Clients/ClientDetails';
import ClientDetailsPage from './pages/Clients/ClientDetailsPage';
import ClientListPageByUserCompany from './pages/Clients/ClientListPageByUserCompany';
import ClientNotes from './pages/Clients/ClientNotes';
import ClientTabsPage from './pages/Clients/ClientTabsPage';
import NearExpiryClientsPage from './pages/Clients/NearExpiryClientsPage';
import SAPClients from './pages/Clients/SAPClients';
import CompanyAssigmnet from './pages/Company/CompanyAssigmnet';
import CompanyDetails from './pages/Company/CompanyDetails';
import CompanyListPageByUserCompany from './pages/Company/CompanyListPageByUserCompany';
import CompanyNotes from './pages/Company/CompanyNotes';
import CompanyTabsPage from './pages/Company/CompanyTabsPage';
import SAPEmployers from './pages/Company/SAPEmployers';
import EnquiryList from './pages/Footfalls/EnquiryList';
import FootfallsList from './pages/Footfalls/FootfallsList';
import InterviewDetailPage from './pages/Interviews/InterviewDetailPage';
import MyOpportunitiesPage from './pages/Opportunities/MyOpportunitiesPage';
import RecruitmentTabsPage from './pages/Recruitment/RecruitmentTabsPage';
import ReportListPage from './pages/Reports/ReportListPage';
import AssignedTasks from './pages/Tasks/AssignedTasks';
import ForwardedTasks from './pages/Tasks/ForwardedTasks';
import MyTasks from './pages/Tasks/MyTasks';
import TasksAssignment from './pages/Tasks/TaskAssignment';
import TestTable from './pages/TestTable';
import TreeView from './pages/TreeView/TreeView';
import VacanciesList from './pages/Vacancies/VacanciesList';
import VacancyTabsPage from './pages/Vacancies/VacancyTabsPage';

// // ----------------------------------------------------------------------

const routes = (isAuthenticated, name, userRole, firstPasswordChanged) => [
  {
    path: 'app',

    element: isAuthenticated ? (
      <DashboardLayout
        isAuthenticated={isAuthenticated}
        name={name}
        userRole={userRole}
        firstPasswordChanged={firstPasswordChanged}
      />
    ) : (
      <Navigate to="/login" />
    ),
    children:
      firstPasswordChanged == 'false'
        ? [
            {
              path: 'dashboard',
              element: <DashboardAppPage firstPasswordChanged={firstPasswordChanged} />,
            },
            { path: 'ChangePassword', element: <ChangePassword /> },
            { path: '*', element: <Navigate to="/404" /> },
          ]
        : userRole === 'Guest'
        ? [
            { path: 'dashboard', element: <DashboardAppPage /> },
            { path: 'ChangePassword', element: <ChangePassword /> },
            { path: 'Footfalls', element: <FootfallsList /> },
            { path: 'CreateFootfall', element: <AddFootfall /> },
            { path: 'CreateEnquiry', element: <CreateEnquiry /> },
            { path: 'EditFootfall/:id', element: <EditFootfall /> },
            { path: 'FootFallDetails/:id', element: <FootFallDetails /> },
            { path: '*', element: <Navigate to="/404" /> },
          ]
        : userRole === 'Master'
        ? [
            { path: 'dashboard', element: <DashboardAppPage /> },
            { path: 'user', element: <UserPage /> },
            { path: 'AddUser', element: <AddUser /> },

            { path: 'TreeView/:id/:checkClient', element: <TreeView /> },

            { path: 'EditUser/:id', element: <EditUser /> },
            { path: 'ChangePassword', element: <ChangePassword /> },
            { path: 'EditCompany/:id', element: <CompanyEditPage /> },
            { path: 'AddCompany', element: <CompanyPage /> },
            { path: 'Companies', element: <CompanyListPage /> },
            { path: 'CompaniesByUserCompany', element: <CompanyListPageByUserCompany /> },
            { path: 'SAPEmployers', element: <SAPEmployers /> },
            { path: 'CompanyDetails/:taskId/:id/:checkClient', element: <CompanyDetailsPage /> },
            { path: 'CompanyDetails/:id', element: <CompanyDetails /> },
            { path: 'CompanyNotes/:id', element: <CompanyNotes /> },
            { path: 'CompanyTabs/:id/:checkClient', element: <CompanyTabsPage /> },

            { path: 'Clients', element: <ClientListPage /> },
            { path: 'ClientsByCompany', element: <ClientListPageByUserCompany /> },
            { path: 'NearExpiryClientsPage/:days', element: <NearExpiryClientsPage /> },
            { path: 'SAPClients', element: <SAPClients /> },
            { path: 'AddClient', element: <ClientPage /> },
            { path: 'EditClient/:id', element: <ClientEditPage /> },
            { path: 'ClientsAssignment', element: <ClientAssigmnet /> },
            { path: 'CompanyAssignment', element: <CompanyAssigmnet /> },
            { path: 'MyOpportunities', element: <MyOpportunitiesPage /> },

            { path: 'CreateTasks/:id/:checkClient', element: <TasksList /> },
            { path: 'MyTasks', element: <MyTasks /> },
            { path: 'AssignedTasks', element: <AssignedTasks /> },
            { path: 'ForwardedTasks', element: <ForwardedTasks /> },
            { path: 'TasksAssignment', element: <TasksAssignment /> },
            { path: 'ClientDetails/:taskId/:id/:checkClient', element: <ClientDetailsPage /> },
            { path: 'ClientDetails/:id', element: <ClientDetails /> },
            { path: 'ClientNotes/:id', element: <ClientNotes /> },
            { path: 'ClientTabs/:id/:checkClient', element: <ClientTabsPage /> },

            { path: 'Footfalls', element: <FootfallsList /> },
            { path: 'CreateFootfall', element: <AddFootfall /> },
            { path: 'CreateEnquiry', element: <CreateEnquiry /> },
            { path: 'EditFootfall/:id', element: <EditFootfall /> },
            { path: 'FootFallDetails/:id', element: <FootFallDetails /> },
            { path: 'EnquiryList', element: <EnquiryList /> },

            { path: 'Vacancies', element: <VacanciesList /> },
            { path: 'CreateVacancy', element: <AddVacancy /> },
            { path: 'CreateJob', element: <CreateJob /> },

            { path: 'EditVacancy/:id', element: <EditVacancy /> },
            { path: 'VacancyDetails/:id', element: <VacancyDetails /> },
            { path: 'VacancyTabsPage/:id', element: <VacancyTabsPage /> },

            { path: 'CreatePosition', element: <AddPosition /> },

            { path: 'Candidates', element: <CandidatesList /> },
            { path: 'AddCandidate', element: <CandidateCreatePage /> },
            { path: 'EditCandidate/:id', element: <CandidateEditPage /> },
            { path: 'FootFallDetails/:id', element: <FootFallDetails /> },
            { path: 'CandidateTabs/:id', element: <CandidateTabsPage /> },
            { path: 'CandidateTabs/:id/:vacancyId', element: <CandidateTabsPage /> },
            { path: 'Recruitment', element: <RecruitmentTabsPage /> },
            { path: 'InterviewDetail/:id/:candidateId', element: <InterviewDetailPage /> },

            { path: 'PerformActivity/:id/:checkClient', element: <PerformActivity /> },
            { path: 'Association/:id/:checkClient', element: <Association /> },

            { path: 'Attachments/:id/:checkClient', element: <AttachmentsList /> },
            { path: 'Calendar', element: <MyCalendar /> },

            // { path: 'Reports', element: <ReportListPage /> },
            { path: 'Reports/:id/:checkClient', element: <ReportListPage /> },
            { path: 'testTable', element: <TestTable /> },

            { path: '*', element: <Navigate to="/404" /> },
          ]
        : [
            { path: 'dashboard', element: <DashboardAppPage /> },
            // { path: 'user', element: <UserPage /> },
            { path: 'AddUser', element: <AddUser /> },

            { path: 'EditUser/:id', element: <EditUser /> },
            { path: 'ChangePassword', element: <ChangePassword /> },
            { path: 'EditCompany/:id', element: <CompanyEditPage /> },
            { path: 'AddCompany', element: <CompanyPage /> },
            { path: 'Companies', element: <CompanyListPage /> },
            { path: 'SAPEmployers', element: <SAPEmployers /> },
            { path: 'CompanyDetails/:taskId/:id/:checkClient', element: <CompanyDetailsPage /> },
            { path: 'CompanyDetails/:id', element: <CompanyDetails /> },
            { path: 'CompanyNotes/:id', element: <CompanyNotes /> },
            { path: 'CompanyTabs/:id/:checkClient', element: <CompanyTabsPage /> },

            { path: 'Clients', element: <ClientListPage /> },
            { path: 'NearExpiryClientsPage/:days', element: <NearExpiryClientsPage /> },
            { path: 'SAPClients', element: <SAPClients /> },
            { path: 'AddClient', element: <ClientPage /> },
            { path: 'EditClient/:id', element: <ClientEditPage /> },
            { path: 'ClientsAssignment', element: <ClientAssigmnet /> },
            { path: 'CompanyAssignment', element: <CompanyAssigmnet /> },
            { path: 'MyOpportunities', element: <MyOpportunitiesPage /> },

            { path: 'CreateTasks/:id/:checkClient', element: <TasksList /> },
            { path: 'MyTasks', element: <MyTasks /> },
            { path: 'AssignedTasks', element: <AssignedTasks /> },
            { path: 'ForwardedTasks', element: <ForwardedTasks /> },
            { path: 'TasksAssignment', element: <TasksAssignment /> },
            { path: 'ClientDetails/:taskId/:id/:checkClient', element: <ClientDetailsPage /> },
            { path: 'ClientDetails/:id', element: <ClientDetails /> },
            { path: 'ClientNotes/:id', element: <ClientNotes /> },
            { path: 'ClientTabs/:id/:checkClient', element: <ClientTabsPage /> },

            { path: 'Footfalls', element: <FootfallsList /> },
            { path: 'CreateFootfall', element: <AddFootfall /> },
            { path: 'CreateEnquiry', element: <CreateEnquiry /> },
            { path: 'EditFootfall/:id', element: <EditFootfall /> },
            { path: 'FootFallDetails/:id', element: <FootFallDetails /> },
            { path: 'EnquiryList', element: <EnquiryList /> },

            { path: 'Vacancies', element: <VacanciesList /> },
            { path: 'CreateVacancy', element: <AddVacancy /> },
            { path: 'CreateJob', element: <CreateJob /> },

            { path: 'EditVacancy/:id', element: <EditVacancy /> },
            { path: 'VacancyDetails/:id', element: <VacancyDetails /> },
            { path: 'VacancyTabsPage/:id', element: <VacancyTabsPage /> },

            { path: 'CreatePosition', element: <AddPosition /> },

            { path: 'Candidates', element: <CandidatesList /> },
            { path: 'AddCandidate', element: <CandidateCreatePage /> },
            { path: 'EditCandidate/:id', element: <CandidateEditPage /> },
            { path: 'FootFallDetails/:id', element: <FootFallDetails /> },
            { path: 'CandidateTabs/:id', element: <CandidateTabsPage /> },
            { path: 'CandidateTabs/:id/:vacancyId', element: <CandidateTabsPage /> },
            { path: 'Recruitment', element: <RecruitmentTabsPage /> },
            { path: 'InterviewDetail/:id/:candidateId', element: <InterviewDetailPage /> },

            { path: 'PerformActivity/:id/:checkClient', element: <PerformActivity /> },
            { path: 'Association/:id/:checkClient', element: <Association /> },

            { path: 'Attachments/:id/:checkClient', element: <AttachmentsList /> },

            // { path: 'Reports', element: <ReportListPage /> },
            { path: 'Reports/:id/:checkClient', element: <ReportListPage /> },
            { path: 'testTable', element: <TestTable /> },

            { path: '*', element: <Navigate to="/404" /> },
          ],
  },
  {
    path: 'login',
    element: <LoginPage />,
  },
  {
    path: '/',
    element: <SimpleLayout />,
    children: [
      { path: 'login', element: <LoginPage /> },
      { path: '404', element: <Page404 /> },
      { path: '/', element: <Navigate to="/app/dashboard" /> },
    ],
  },
];

export default routes;
